{
	"priceForecast": {
		"title": "Price forecast",
		"description": "12-month price target for {{symbol}} based on {{count}} analysts: high target {{maxPrice}}, low target {{minPrice}}.",
		"maxPrice": "Max. price",
		"avgPrice": "Avg. price",
		"minPrice": "Min. price",
		"maxLine": "Max.",
		"minLine": "Min.",
		"avgLine": "Avg."
	}
}
